import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

export default function SessionAlertDialog() {

    const [open, setOpen] = React.useState(localStorage.getItem('session') && localStorage.getItem('oldSession') && localStorage.getItem('session') !== localStorage.getItem('oldSession') );

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    return (
        <div>
            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    Увага!
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Зафіксовано діючу сесію!<br />
                        Можливо, ви відкрили програму в декількох вкладках броузера.<br />
                        Майте на увазі, що сесії всіх відкритих вкладок будуть перезаписані поточною і всі запити будуть працювати від останньої компанії, під якою був здійснений вхід.
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose}>OK</Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}